<template>
	<div class="full" style="background-color: white;" >
		<div class="module_container full" style="position: relative;">
			<el-container class="full" style="position: relative;">
				<el-main class="main flex">
					<div style="position: relative;width: 100%;flex: 1;" :style="{height:'100%'}">
						<vxe-grid v-if="list_gridOptions" v-bind="list_gridOptions" :loading="loading"
							@toolbar-button-click="list_toolbarButtonClickEvent" ref="exchangediffList" ></vxe-grid>
					</div>
				</el-main>
			</el-container>
		</div>
	</div>
</template>
<style scoped>
	.main {
		position: relative;
		width: 100%;
		height: 100%;
		padding: 5px;
		box-sizing: border-box;
		flex-direction: column;
		overflow: hidden;

	}
</style>
<script>
	import listMixins from '@_system/components/base/mixins/list/list.js'
	export default {
		mixins: [listMixins],
		props: {
			data: {
				default: () => {
					return []
				}
			},
		},
		data() {
			return {
				loading:false,
				currentrow:{},
				planList:[],
				shopList:[],
				ids:[],
				list_formConfig: [{
					field: 'ordercode',
					title: '订单号',
					itemRender: {
						name: '$input'
					}
				}],
				list_columns: [
					// {
					// 	type: 'checkbox',
					// 	title: '#',
					// 	width:50,
					// 	fixed:'left'
					// },
					{
						field: 'ordercode',
						title: '订单号',
					},
					{
						field: 'shopname',
						title: '店铺',
					},
					{
						field: 'warehouse',
						title: '仓库',
					},
					{
						field: 'payment',
						title: '买家实付',
					},
					{
						field: 'remarkinline',
						title: '线上备注',

					},
					{
						field: 'remark',
						title: '系统备注',

					},
					{
						field: 'amount',
						title: '退款金额',
						fixed:'right'
					},
		// 			{
		// 				field: 'status',
		// 				title: '状态',
		// 				width: 100,
		// 				slots: {
		// 					default: ({row}) => {
		// 						if(row.status == 1){
		// 							return '开启'
		// 						}else if(row.status == 0){
		// 							return '关闭'
		// 						}else{
		// 							return null
		// 						}
		
		// 					}
		// 				}
		// 			},
					{
						title: '操作',
						fixed: "right",
						align: 'center',
						width: 130,
						slots: {
							default: ({row}) => {
								return [
									<el-button type = "text" size = "mini" onClick = {() => {this.createexchangeorder(row)}}>创建售后单</el-button>
								]
							}
						}
					}				
				]
				// list_footerField:[
				// 	{field:'needamount',toFixed:2}
				// ]
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {

		},
		methods: {
			listplan(){
				return new Promise((reslove)=>{
					this.$api.campaign.listplan().then((res)=>{
						this.planList = res.list
						this.shopList = res.shop
						reslove()
					})
				})
			},
			
			list_beforeCreateGrid(gridOptions) {
						gridOptions.pagerConfig = {
							enabled: false,
							autoHidden: false,
							border: true,
							size: 'mini',
							perfect: false,
							currentPage: 1,
							pageSize: 20,
							pageSizes: [10, 20, 50, 100, 200, 5000],
						}				
						gridOptions.formConfig.span = 4
						gridOptions.pagerConfig.enabled = true				
						gridOptions.toolbarConfig.buttons = [{
							name: '导出',
							status: 'success',
							code: 'export'
						},{
							name: '获取订单',
							status: 'primary',
							code: 'pull'
						}]					
			},
			createexchangeorder(row){
				console.log(row)
				
			},
			pull(){
				this.loading = true
				this.$api.exchangediff.pull().then(() => {
					this.loading = false
					this.customreload()
				},()=>{
					this.loading = false
				})
			},
			list(page, updateForm) {
				return new Promise((resolve) => {
					this.$api.exchangediff.list({
						...page,
						...updateForm
					}).then((res) => {
						resolve(res)
					},()=>{
						resolve()
					})
				})
			},
			editFormSuccess(){
				this.ids = []
				this.customreload()
			},
			submit() {
				//this.init()
			},
			reset() {
				//this.init()
			},
			planFormHide(){
				// this.list_gridOptions = null
				this.list_init()
			},
			customreload() {
				this.$refs.exchangediffList.commitProxy('query')
			}
		},
		components: {

		}
	}
</script>